export default {
  title: 'Commande n° {{number}}',
  labels: {
    item: '{{count}} article',
    item_other: '{{count}} articles',
  },
  buttons: {
    details: 'Détails',
  },
  fulfillment_statuses: {
    created: 'Créée',
    reviewed: 'Examinée',
    accepted: 'Acceptée',
    preparing: 'En préparation',
    ready: 'Prête',
    on_delivery: 'En livraison',
    picked: 'Récupérée',
    rejected: 'Refusée',
  },
};
